import { render } from "./CVHero.vue?vue&type=template&id=6d6289e4&scoped=true"
import script from "./CVHero.vue?vue&type=script&lang=js"
export * from "./CVHero.vue?vue&type=script&lang=js"

import "./CVHero.vue?vue&type=style&index=0&id=6d6289e4&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d6289e4"]])

export default __exports__